module.exports = __webpack_public_path__ + "themes/non-default/brandLogoDark.f72ba96cfe1c56d6793a8b2fbaeb26ab.svg";